import * as shopping from "./shopping";
import * as pay from "./pay";

export const naver = {
    ...shopping,
    ...pay
}
